// Copyright (c) StrangeBee 2023

import { Badge } from 'antd';
import { BadgeProps } from 'antd/lib/badge';
import React, { ReactElement } from 'react';

import './DisplayBadge.scss';

interface DisplayBadgeProps {
    status: BadgeProps['status'];
    onClick?: () => void;
}

const DisplayBadge = ({ status, onClick }: DisplayBadgeProps): ReactElement => (
    <div
        role="button"
        onClick={onClick}
        className={`display-badge__container ${onClick ? 'display-badge__clickable' : ''}`}
    >
        <Badge status={status} className="display-badge__size" />
    </div>
);

export default DisplayBadge;
